"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactHookForm = require("react-hook-form");
var _react2 = require("@emotion/react");
var _utils = require("../../../utils");
var _Form = _interopRequireDefault(require("../../hocs/Form"));
var _Uploader = _interopRequireDefault(require("./Uploader"));
var _InputFeedback = _interopRequireDefault(require("../../hocs/InputFeedback"));
var _Row = _interopRequireDefault(require("../../layout/Row"));
var _Button = _interopRequireDefault(require("../../atoms/Button"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  defaultValue: '',
  disabled: false,
  width: '100%',
  accept: '.jpg, .jpeg, .png, .svg, .webp, application/pdf',
  className: '',
  onChangeInput() {}
};
function InputFile(props) {
  const {
    name,
    label,
    width,
    accept,
    disabled,
    defaultValue,
    doNotShowFeedback,
    doNotShowErrors,
    containerStyles,
    uploaderStyles,
    className,
    onChangeInput
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const {
    control,
    formState: {
      errors
    }
  } = _Form.default.useForm();
  const loadedFile = _Form.default.useWatch({
    name,
    control
  });
  const fieldError = (0, _utils.getObjectField)(errors, name);
  const Container = (0, _react.useMemo)(() => doNotShowFeedback ? _react.Fragment : _InputFeedback.default, [doNotShowFeedback]);
  const goToPreview = () => {
    if (typeof loadedFile === 'string') {
      window.open(loadedFile, '_blank');
      return;
    }
    window.open(URL.createObjectURL(loadedFile), '_blank');
  };
  return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: name,
    control: control,
    render: _ref => {
      var _loadedFile$name;
      let {
        field: {
          onChange
        }
      } = _ref;
      return /*#__PURE__*/_react.default.createElement(Container, {
        label: label,
        errors: fieldError,
        hasError: Boolean(fieldError === null || fieldError === void 0 ? void 0 : fieldError.message),
        name: name,
        doNotShowErrors: doNotShowErrors,
        className: className,
        styles: containerStyles
      }, /*#__PURE__*/_react.default.createElement(_Row.default, {
        gap: 35
      }, /*#__PURE__*/_react.default.createElement(_Uploader.default, {
        accept: accept,
        width: width,
        disabled: disabled,
        onChange: f => {
          onChange === null || onChange === void 0 || onChange(f);
          onChangeInput === null || onChangeInput === void 0 || onChangeInput(f);
        },
        styles: uploaderStyles,
        loadedFile: loadedFile
      }), Boolean(loadedFile) && /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "link",
        align: "right",
        children: typeof loadedFile === 'string' ? loadedFile === null || loadedFile === void 0 ? void 0 : loadedFile.slice(-17) : (loadedFile === null || loadedFile === void 0 || (_loadedFile$name = loadedFile.name) === null || _loadedFile$name === void 0 ? void 0 : _loadedFile$name.slice(-17)) || '',
        width: "auto",
        onClick: goToPreview,
        styles: cssPreviewButtonStyles
      })));
    },
    defaultValue: defaultValue
  });
}
const cssPreviewButtonStyles = (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  min-width: 105px;\n\n  @media screen and (min-width: 768px) {\n    width: 60% !important;\n  }\n\n  @media screen and (min-width: 1366px) {\n    width: 40%;\n  }\n"])));
var _default = exports.default = InputFile;